export default __webpack_public_path__ + "static/media/scan.9cee104b.png";